import Pusher from "pusher-js"
import Echo from "laravel-echo"
import { getApiUrl } from "./getApiUrl"
import { getCookie } from "./cookies"
import { CSRF_TOKEN, USER_OBJECT_COOKIE } from "./constants"

declare global {
  interface Window {
    Echo: any
    Pusher: any
  }
}

const EchoConfig = () => {
  if (typeof window !== undefined && typeof window.Echo !== undefined) {
    const authData = getCookie(USER_OBJECT_COOKIE)

    window.Pusher = Pusher

    const apiUrl = new URL(String(getApiUrl()))
    let currentPusher = "your-pusher-key"
    let currentProjectId = ""
    if (authData) {
      currentProjectId = JSON.parse(String(authData ?? "{}"))?.current_project_id
      currentPusher = `project_${currentProjectId}`
    }

    window.Echo = new Echo({
      broadcaster: "pusher",
      disableStats: true,
      client: new Pusher(currentPusher, {
        wsPort: 6001,
        wssPort: 6001,
        forceTLS: false,
        disableStats: true,
        wsHost: apiUrl.hostname + process.env.REACT_APP_PUBLIC_SOCKET_SUFFIX,
        cluster: "NaN",
        enabledTransports: ["ws", "wss"],
        authorizer: (channel, options) => {
          return {
            authorize: async (socketId, callback) => {
              const bodyData = new FormData()

              bodyData.append("socket_id", socketId)
              bodyData.append("channel_name", channel.name)
              const csrfToken = String(getCookie(CSRF_TOKEN))
              try {
                const response = await fetch(`${apiUrl.origin}/api/v1/public/broadcasting/auth`, {
                  method: "POST",
                  body: bodyData,
                  credentials: "include",
                  headers: {
                    Project: currentProjectId,
                    "X-XSRF-TOKEN": csrfToken,
                  },
                })

                const data = await response.json()
                callback(null, data)
              } catch (error: any) {
                callback(error, null)
              }
            },
          }
        },
      }),
    })

    window.Echo.connector.pusher.connection.strategy.transports.wss.transport.manager.livesLeft = Infinity

    window.Echo.connector.pusher.connection.bind("state_change", (states: any) => {
      if (states.current === "disconnected") {
        window.Echo.connector.pusher.connect()
      }
    })
  }
}

export default EchoConfig
